<template>
  <label :class="['p-radio', { checked: value === assignedValue, disabled }]">
    <input
      v-bind="$attrs"
      type="checkbox"
      class="checkbox"
      :checked="value === assignedValue"
      :disabled="disabled"
      @change="onChange"
    />
    <span v-if="text" class="body-m-regular">
      {{ text }}
    </span>
  </label>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'PRadio',
  props: {
    text: {
      type: String,
      default: '',
    },
    value: {
      type: [Boolean, String, Number],
      required: true,
    },
    assignedValue: {
      type: [Boolean, String, Number],
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['input', 'change'],
  setup(props, { emit }) {
    function onChange(): void {
      emit('input', props.assignedValue);
      emit('change', props.assignedValue);
    }

    return {
      onChange,
    };
  },
});
</script>

<style scoped lang="scss" src="./p-radio-scss.scss" />
